import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  id: "Nav",
  class: "left"
}
const _hoisted_3 = { class: "back" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "maintitle s60" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = {
  id: "Main",
  class: "right"
}
const _hoisted_9 = {
  class: "logo",
  "data-color": "cyan50"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = { class: "intro" }
const _hoisted_13 = { class: "maintitle s36" }
const _hoisted_14 = {
  ref: "form",
  class: "form"
}
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { for: "Email" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_19 = { class: "cta" }

import { ref } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountEmailConfirmSend',
  setup(__props) {

const localizer = Localizer;
const formHelper = FormHelper;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);

function back() {
    window.history.back();
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoading.value = true;

    try {
        let response = await Axios.post(routes.Account_User_EmailConfirmSend, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

        let result = response.data;

        isSuccess.value = true;
        window.location.href = result.redirectUrl;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }
    
    isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back())),
          class: "button icon fastic-circle-left",
          "aria-label": _unref(localizer).get('App.Common.PageBack')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(localizer).get("Account.Common.EmailConfirmSend_Title")), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(localizer).get("Account.Common.EmailConfirmSend_Description")), 1)
      ]),
      _createVNode(_component_app_footer)
    ]),
    _createElementVNode("main", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          href: _unref(routes).Home
        }, [
          _createElementVNode("img", {
            src: "/images/logo.svg",
            width: "125",
            height: "35",
            alt: _unref(localizer).get('App.Common.Beghelli')
          }, null, 8, _hoisted_11)
        ], 8, _hoisted_10)
      ]),
      _createElementVNode("div", {
        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
        class: "content"
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(localizer).get("App.Common.InsertAddress")), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(localizer).get("App.Form.Email")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "Email",
                placeholder: _unref(localizer).get('App.Form.EmailPlaceholder'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Email', validationErrors.value) }, 'input w300'])
              }, null, 10, _hoisted_17), [
                [
                  _vModelText,
                  formData.value.email,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("fieldset", null, [
            (validationErrors.value.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: _normalizeClass([{ 'loading': isLoading.value }, 'button']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm()))
              }, [
                (!isLoading.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ], 512)
      ], 32)
    ])
  ]))
}
}

})